import Handsontable from 'handsontable'

/**
 * Workaround to fix increasing height of Hot container. ver 0.34.5.
 * @param {any} hotInstance
 */
export default function (hotInstance) {
    
    if (!hotInstance) {
        return;
    }

    const alignOverlaysWithTrimmingContainer = getHotFunction(hotInstance);
    if (isBuggedImplementation(alignOverlaysWithTrimmingContainer)) {
        applyFix(hotInstance);
    }
}

function isBuggedImplementation(currentFunction) {
    if (!currentFunction) {
        return false;
    }

    const asString = currentFunction.toString();

    return asString.indexOf('} else {') > -1 &&
        (asString.indexOf("(trimmingElement.className.indexOf('handsontable') !== -1)") < 0 ||
            asString.indexOf("(trimmingElement.className.indexOf('handsontable') != -1)") < 0);
}

function getHotFunction(hotInstance) {
    return hotInstance.view.wt.wtTable.alignOverlaysWithTrimmingContainer;
}

function applyFix(hotInstance) {
    const self = hotInstance.view.wt.wtTable;
    const getTrimmingContainer = Handsontable.dom.getTrimmingContainer;
    const getStyle = Handsontable.dom.getStyle;

    self.alignOverlaysWithTrimmingContainer =
        function () {
            const trimmingElement = (0, getTrimmingContainer)(self.wtRootElement);

            if (!self.isWorkingOnClone()) {
                self.holder.parentNode.style.position = 'relative';

                if (trimmingElement === window) {
                    const preventOverflow = self.wot.getSetting('preventOverflow');

                    if (!preventOverflow) {
                        self.holder.style.overflow = 'visible';
                        self.wtRootElement.style.overflow = 'visible';
                    }
                } else if (trimmingElement.className.indexOf('handsontable') !== -1) {
                    self.holder.style.width = (0, getStyle)(trimmingElement, 'width');
                    self.holder.style.height = (0, getStyle)(trimmingElement, 'height');
                    self.holder.style.overflow = '';
                }
            }
        };
}


// WEBPACK FOOTER //
// ./App/components/Handsontable/handsontable-fixes/heightBugFix.js